type Entries<T> = { [K in keyof T]: [K, T[K]] }[keyof T];
// eslint-disable-next-line @typescript-eslint/ban-types
export function getObjectEntries<T extends object>(t: T): Entries<T>[] {
  return Object.entries(t) as any;
}

export const filterUndefineds = <T>(obj: T | undefined): obj is T => obj !== undefined;

export const filterNulls = <T>(obj: T | null): obj is T => obj !== null;
